import './app.scss';

import React from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Switch,
  Route,
} from 'react-router-dom';
import * as Routes from './routes';
import { HomePage } from './pages';

function App() {
  return (
    <div className='App'>
      <Router basename='/react-typetool'>
        <Switch>
          <Route exact path={Routes.LANDING} component={HomePage} />
          <Redirect from={Routes.HOME} to={Routes.LANDING} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
